module.exports = __webpack_public_path__ + "img/MLW_V.40825a33.svg";